// src/data/projectsData.js

import WarmStone_img from '../assets/thumbnails/WarmStone_img.jpg';
import BioMirror_img from '../assets/thumbnails/BioMirror_img.jpg';
import HeartBloom_img from '../assets/thumbnails/HeartBloom_img.png';
import HeartCalligraphy_img from '../assets/thumbnails/HeartCalligraphy_img.png';

//Notes:
// - id: unique identifier for each project, used for routing and data management
// - period: project duration, shown on the project card and detail page
// - slug: URL-friendly string for routing (e.g., /projects/heartbloom)
// - title: project name, shown on the project card and detail page
// - summary: 50 words summary of the project, shown on the project card and detail page


export const projectsData = [
     {
    id: 7,
    period: '2025-2026',
    slug: 'warmstone',      // used in URL
    title: 'WarmStone',
    summary: 'WarmStone explores how handcrafted ceramic objects—small, tactile stones—can offer haptic comfort, reduce stress, and cultivate mindfulness in everyday life.',
    thumbnail: WarmStone_img,
    keywords: ['Haptic comfort', 'Stress reduction'],
   },

    {
    id: 3,
    period: '2020-2022',
    slug: 'biomirror',      // used in URL
    title: 'BioMirror',
    summary: 'Much like a traditional mirror reflects outward appearance, BioMirror reveals internal physiological processes, offering users an embodied and intuitive way to perceive and engage with their bodily states.',
    thumbnail: BioMirror_img,
    keywords: ['Bio-responsive objects', 'Tangible interaction'],
 },

     {
    id: 2,
    period: '2020-2022',
    slug: 'heartbloom',      // used in URL
    title: 'HeartBloom',
    summary: 'HeartBloom created a tangible interface that lets individuals see, hear, and feel their heart rhythms. Using floral metaphors to visualize heart rate variability, it reflects the body’s natural biorhythms.',
    thumbnail: HeartBloom_img,
    keywords: ['Public Installation', 'Metaphorical Visualization'],
 },

     {
    id: 1,
    period: '2020-2022',
    slug: 'heartcalligraphy',      // used in URL
    title: 'Heart Calligraphy',
    summary: 'Heart Calligraphy visualizes heart rate variability through abstract artworks generated by the Bio-Plotter.',
    thumbnail: HeartCalligraphy_img,
    keywords: ['Biofeedback', 'Art Visualization'],
 },

];



